"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mark = void 0;
var Mark_1 = require("./Mark");
Object.defineProperty(exports, "Mark", { enumerable: true, get: function () { return Mark_1.Mark; } });
